export const GET_INTERVAL_LIST_DATA = 'GET_INTERVAL_LIST_DATA'
export const SET_INTERVAL_LOADING = 'SET_INTERVAL_LOADING'
export const CLEAR_INTERVAL = 'CLEAR_INTERVAL'
